import axios from 'axios';

export const DEMO = 'front/sign-up/demo';

export function createDemoUser(params) {
  return axios.post(DEMO, { ...params });
}
